













import { Component, Prop } from 'vue-property-decorator'

import LocalVue from '@plugin/Common/classes/related-products/local-vue.class'
import { appConstants } from '@plugin/Common/constants/related-products/app.constants'
import RelatedProducts from '@plugin/Common/components/related-products/RelatedProducts.vue'

@Component({
  components: { RelatedProducts },
})
export default class RelatedProductsViewComponent extends LocalVue {
  @Prop({
    type: String,
    default: '',
  })
  public title: string

  public portalId: string = appConstants.portalId

  get selectedProductId(): number | undefined {
    return this.$store?.state?.products?.selectedProduct?.Id
  }
}
